import React from 'react';
export const useStateExt = (initialValue, name) => {
    const newLocal = React.useState(initialValue);
    const [value, setValue] = newLocal;
    //console.log(name, value);       
    //React.useDebugValue(`${name}: ${value}`);
    return [value, setValue];
}